// @flow
import { connect } from 'react-redux'
import MediaLoader from './MediaLoader'
import * as mediaOperations from '../../redux/ducks/media/operations'
import { getMedia } from '../../redux/selectors'
import type { Store } from '../../redux/ducks'
import _ from 'lodash'
import authenticityToken from '../../shared/authenticityToken'
import type { ImageSizeRestrictions } from '../types'

type OwnProps = {|
  mediaType: string,
  storeId: ?string,
  onLoad: (Array<string>) => void,
  imageSizeRestrictions?: ImageSizeRestrictions,
  errors?: Array<string>,
  height?: number,
  width?: number,
  skipMediaUpload?: boolean,
  multiple?: boolean,
  withoutMediaPreview?: boolean,
  maxImageSize?: number,
  title?: string,
  titleFontSize?: number
|}

function mapStateToProps(state: Store, ownProps: OwnProps) {
  const { storeId } = ownProps
  return {
    media: storeId ? getMedia(state, storeId) : null,
    authenticityToken: authenticityToken()
  }
}

function mapDispatchToProps(dispatch: Function, ownProps: OwnProps) {
  const { onLoad } = ownProps
  return {
    onMediasLoad: (medias) => onLoad(_.map(medias, (media) => mediaOperations.putMedia(media)))
  }
}

const MediaLoaderContainer = connect<Object, OwnProps, _, _, _, _>(
  mapStateToProps,
  mapDispatchToProps
)(MediaLoader)

export default MediaLoaderContainer
